"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePrefixedKey = makePrefixedKey;
exports.deleteFrom = deleteFrom;
exports.getFrom = getFrom;
exports.getFromBatch = getFromBatch;
exports.hasFrom = hasFrom;
exports.setFrom = setFrom;
exports.setFromSafe = exports.getFromSafe = exports.LOCAL_SETTINGS_PREFIX = void 0;

var _immutable = require("immutable");

var _enviro = _interopRequireDefault(require("enviro"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _isString = _interopRequireDefault(require("transmute/isString"));

var LOCAL_SETTINGS_PREFIX = 'LocalSettings:Sales:';
/**
 * Prefixes `key` with the local settings namespace.
 *
 * @example
 * makePrefixedKey('testing') === 'LocalSettings:Sales:testing'
 *
 * @param  {String}
 * @return {String}
 */

exports.LOCAL_SETTINGS_PREFIX = LOCAL_SETTINGS_PREFIX;

function makePrefixedKey(key) {
  (0, _invariant.default)((0, _isString.default)(key) && key.length > 1, 'expected `key` to be a non-empty string but got `%s`', key);
  return LOCAL_SETTINGS_PREFIX + key;
}
/**
 * Removes `key` from `storage`.
 *
 * @example
 * deleteFrom(localStorage, 'setting');
 *
 * @param  {Object}
 * @param  {String}
 * @return {void}
 */


function deleteFrom(storage, key) {
  try {
    delete storage[makePrefixedKey(key)];
  } catch (error) {
    if (!_enviro.default.isProd()) {
      // eslint-disable-next-line no-console
      console.error('Error: deleteFrom:', error);
    }
  }
}
/**
 * Retrieves `key` from `storage`.
 * Returns the result of JSON.parse'ing the string found in storage.
 * Returns `undefined` if storage access or JSON.parse fail.
 *
 * @example
 * getFrom(localStorage, 'setting') === true
 *
 * @param  {Object}
 * @param  {String}
 * @return {any}
 */


function getFrom(storage, key) {
  try {
    var entry = storage[makePrefixedKey(key)];

    if (entry === undefined) {
      return entry;
    }

    return JSON.parse(entry);
  } catch (error) {
    if (!_enviro.default.isProd()) {
      // eslint-disable-next-line no-console
      console.error('Error: getFrom:', error);
    }

    return undefined;
  }
}
/**
 * @deprecated This method can be removed once `getFromSafe`
 *             calls have been replaced with `getFrom` in
 *             all dependents.
 */


var getFromSafe = getFrom;
exports.getFromSafe = getFromSafe;

function getFromBatch(storage, keys) {
  return keys.reduce(function (results, key) {
    return results.set(key, getFrom(storage, key));
  }, (0, _immutable.Map)());
}
/**
 * Returns `true` if `key` is set in storage; otherwise `false`.
 *
 * @example
 * hasFrom(localStorage, 'setting'); //=> true
 * hasFrom(localStorage, 'unknown'); //=> false
 *
 * @param  {Object}
 * @param  {String}
 * @return {bool}
 */


function hasFrom(storage, key) {
  try {
    return Object.prototype.hasOwnProperty.call(storage, makePrefixedKey(key));
  } catch (error) {
    if (!_enviro.default.isProd()) {
      // eslint-disable-next-line no-console
      console.error('Error: hasFrom:', error);
    }

    return undefined;
  }
}
/**
 * Adds `value` to `storage` at `key`.
 * JSON.stringify's `value` before writing to storage.
 * Returns `value` if set successfully; otherwise `undefined`.
 *
 * @example
 * setFrom(localStorage, 'setting', true);
 *
 * @param  {Object}
 * @param  {String}
 * @param  {any}
 * @return {any}
 */


function setFrom(storage, key, value) {
  try {
    storage[makePrefixedKey(key)] = JSON.stringify(value);
    return value;
  } catch (error) {
    if (!_enviro.default.isProd()) {
      // eslint-disable-next-line no-console
      console.error('Error: setFrom:', error);
    }

    return undefined;
  }
}
/**
 * @deprecated This method can be removed once `setFromSafe`
 *             calls have been replaced with `setFrom` in
 *             all dependents.
 */


var setFromSafe = setFrom;
exports.setFromSafe = setFromSafe;